class Api {
  static actionTypeEnum = {
    read: "read",
  };

  levelId = {};
  isStandAlone = null;
  baseUrl = "";

  constructor(auth) {
    this.levelId = { realm: auth.realm?.id, org: auth.orgs?.id, site: auth.sites?.id };
    this.isStandAlone = this._checkStandAlone();
    this.baseUrl = this._getBaseUrl();

    Api.instance = this;
  }

  static init(auth) {
    Api.instance = null;
    return new Api(auth);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  }

  _getBaseUrl() {
    return this.isStandAlone ? `/orgs/:orgId/sites/:siteId` : `/ents/:entId/orgs/:orgId/sites/:siteId`;
  }

  getDeviceRebootParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/deviceReboot`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getDeviceRebootDevicesParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/deviceReboot/devices`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getPoEErrorPortListParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/poeError/portList`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getPoEErrorParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/PoEError`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getUplinkInstabilityDevicesParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/uplinkInstability/devices`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getUplinkInstabilityParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/uplinkInstability`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getSystemBottleneckThresholdUpdateParams(threshold) {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/systemBottleneck/threshold`;
    return {
      apiKey: `${url}.update`,
      restfulPlaceholders: params,
      params: { data: { threshold } },
    };
  }

  getSystemBottleneckDevicesParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/systemBottleneck/devices`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getSystemBottleneckParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/systemBottleneck`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }

  getFirmwareStatusParams() {
    const params = this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site };
    let url = `${this.baseUrl}/operations/firmwareStatus`;
    return {
      apiKey: `${url}.read`,
      restfulPlaceholders: params,
      params: {},
    };
  }
}

export default Api;
